var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditorList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .IconEditorList_a {\n                fill: #fff;\n                opacity: 0;\n            }\n\n            .IconEditorList_b {\n                fill: #304669;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1756 -299)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "IconEditorList_a",
    width: 24,
    height: 24,
    transform: "translate(1756 299)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2047 521.229)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-288 -219.229)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IconEditorList_b",
    d: "M-275.26-217.28a.317.317,0,0,1,0-.459l1.392-1.392a.316.316,0,0,1,.458,0l2.309,2.309a.317.317,0,0,1,0,.459l-1.392,1.392a.316.316,0,0,1-.458,0Zm-6.19,11.3,7.614-7.614a.294.294,0,0,0-.033-.426l-2.309-2.325a.3.3,0,0,0-.426-.033l-7.631,7.614-1.146,3.93Zm-6.55,2.456v1.31h18.34v-1.31Zm0,0",
    transform: "translate(288 219.229)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorList);
export default __webpack_public_path__ + "static/media/IconEditorList.5ab98e0217c14132e3ab984e1a7ae970.svg";
export { ForwardRef as ReactComponent };